// @core/api/endpoints/secret/list_certificates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCertificatesResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * List certificates
 * Returns all certificates issued by the PKI engine, optionally filtered by status or type.
 */
export async function ListCertificates(
  engine_id: string,
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    sort?: string | number | boolean;
    status?: string | number | boolean;
    type?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListCertificatesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/certs`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.get<ListCertificatesResponse>(requestPath, { ...requestOptions, params });
}
